/**
 * Formats a string into a slug by:
 * - Removing special characters (e.g., colons, semicolons, punctuation).
 * - Replacing whitespace with hyphens.
 * - Converting to lowercase.
 *
 * @param {string} str - The string to be formatted.
 * @return {string} - The formatted slug.
 */
export const formatStringToSlugAllLowercase = (str) => {
  return str
    .replace(/[^\w\s-]/g, '') // Remove special characters except spaces and hyphens
    .trim() // Remove leading/trailing spaces
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .toLowerCase(); // Convert to lowercase
};